import Button from "../../../../Elements/Button/Button";
import getTextKeysForModal from "./helpers/getTextKeysForModal";
import Icon from "../../../../Elements/Icon/Icon";
import { LinkToNewTab } from "../../../../Elements/Link/Link";
import { useContent } from "../../../../../contexts/contentContext/contentContext";
import { useModal } from "../../../../../contexts/modalContext/modalContext";
import type { DowngradeTypeT } from "./models/models";

import styles from "./styles.module.scss";

interface StorageOverflowModalI {
  downgradeType: DowngradeTypeT;
}

/**
 * Renders warning modal when downgrade is forbidden because of
 * exceeded extra storage, sub users quantity or JUMBOforms quantity.
 */

const StorageOverflowModal = ({ downgradeType }: StorageOverflowModalI) => {
  const { getTextByKey, getHtmlByKey } = useContent();
  const { closeModal } = useModal();
  const textKeys = getTextKeysForModal(downgradeType);

  return (
    <div className={styles.storageOverflowModalWrapper}>
      <Icon name="warning" red iconClass={styles.icon} />
      <div className={styles.title}>{getTextByKey(textKeys.title)}</div>
      <div className={styles.description}>
        {getHtmlByKey(textKeys.description)}
      </div>
      <div className={styles.actions}>
        <Button className="new-button" blank onClick={closeModal}>
          {getTextByKey("cancel")}
        </Button>
        {/*@ts-ignore*/}
        <LinkToNewTab page={textKeys.manageButtonLink} isNewTab>
          <Button className="new-button">
            {getTextByKey(textKeys.manageButton)}
          </Button>
        </LinkToNewTab>
      </div>
    </div>
  );
};

export default StorageOverflowModal;
